import createReactComponent from '../createReactComponent';
export default createReactComponent('outline', 'chevrons-up-left', 'IconChevronsUpLeft', [["path",{"d":"M7 15v-8h8","key":"svg-0"}],["path",{"d":"M11 19v-8h8","key":"svg-1"}]]);